import {AutoReplyTypeEnum} from '../../../service/reviews/reviews-response-templates';

// The backend keeps the reply type in `templateSelectionStrategy`: "gpt" marks a neural network rule,
// while a template rule must use one of the template orders below.
const GPT_TEMPLATE_SELECTION_STRATEGY = 'gpt';

const TEMPLATE_SELECTION_STRATEGIES: ReadonlySet<string> = new Set(['random', 'successively']);

const DEFAULT_TEMPLATE_SELECTION_STRATEGY = 'random';

function isTemplateSelectionStrategy(strategy: string | undefined): strategy is string {
    return typeof strategy === 'string' && TEMPLATE_SELECTION_STRATEGIES.has(strategy);
}

// Returns the first candidate that is a valid template order, otherwise "random".
export function getTemplateSelectionStrategy(...candidates: Array<string | undefined>): string {
    return candidates.find(isTemplateSelectionStrategy) || DEFAULT_TEMPLATE_SELECTION_STRATEGY;
}

export function getTemplateSelectionStrategyForReplyType(
    replyType: AutoReplyTypeEnum | undefined,
    ...candidates: Array<string | undefined>
): string {
    return replyType === AutoReplyTypeEnum.NeuralNetwork
        ? GPT_TEMPLATE_SELECTION_STRATEGY
        : getTemplateSelectionStrategy(...candidates);
}
